import * as React from "react";

export const MailBlockIcon = (props: any) => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.6458 7.16292C26.6458 5.87959 25.5958 4.82959 24.3125 4.82959H5.64583C4.3625 4.82959 3.3125 5.87959 3.3125 7.16292V21.1629C3.3125 22.4463 4.3625 23.4963 5.64583 23.4963H24.3125C25.5958 23.4963 26.6458 22.4463 26.6458 21.1629V7.16292ZM24.3125 7.16292L14.9792 12.9963L5.64583 7.16292H24.3125ZM24.3125 21.1629H5.64583V9.49626L14.9792 15.3296L24.3125 9.49626V21.1629Z"
      fill={props.color ?? "#2D5BFF"}
    />
  </svg>
);
